import React from 'react';
import { motion } from 'framer-motion';
// import { Users, Trophy, UserCheck, Heart, MessageCircle, Dumbbell, Download, Globe, ExternalLink } from 'lucide-react';
import { Download, LogIn } from 'lucide-react';

interface HighlightReelProps {
  onDownloadClick: () => void;
}

const HighlightReel: React.FC<HighlightReelProps> = ({ onDownloadClick }) => {
  /*
  const features = [
    {
      icon: Users,
      title: 'Mercado de Pases y Amistosos',
      description: 'Encontrá equipos o fichá jugadores para tu plantel',
      color: 'from-blue-500 to-blue-600',
      delay: 0.1
    },
    {
      icon: Trophy,
      title: 'Torneos',
      description: 'Encontrá todos los torneos, y para ellos, el mejor software para que tu experiencia sea la mejor.',
      color: 'from-green-500 to-green-600',
      delay: 0.2
    },
    {
      icon: UserCheck,
      title: 'Perfiles',
      description: 'El CV "historia clínica" del jugador y equipo con todo el historial completo de partidos, estadísticas y logros.',
      color: 'from-purple-500 to-purple-600',
      delay: 0.3
    },
    {
      icon: Heart,
      title: 'Comunidad',
      description: 'Conocé gente apasionada por el fútbol, conectá con jugadores de tu zona y construí amistades que duran toda la vida.',
      color: 'from-red-500 to-red-600',
      delay: 0.4
    },
    {
      icon: MessageCircle,
      title: 'Chat',
      description: 'El chat más potente y especializado para el fútbol, diseñado para equipos, torneos y comunicación futbolera.',
      color: 'from-orange-500 to-orange-600',
      delay: 0.5
    },
    {
      icon: Dumbbell,
      title: 'Entrenamiento y Nutrición',
      description: 'Elevá tu potencial con planes de entrenamiento personalizados y consejos de nutrición para optimizar tu rendimiento en la cancha.',
      color: 'from-indigo-500 to-indigo-600',
      delay: 0.6
    }
  ];
  */

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        {/* La App que nos conecta - OCULTA */}
        {/* 
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-mas10-dark mb-6">
            La App que nos conecta
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubrí las funcionalidades que hacen de +10 la app definitiva para el fútbol que jugamos todos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: feature.delay }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="group"
            >
              <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
                <div className={`w-16 h-16 bg-gradient-to-r ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <feature.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-display font-bold text-mas10-dark mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
                <div className="mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className={`w-full h-1 bg-gradient-to-r ${feature.color} rounded-full`}></div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        */}

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
          className="text-center mt-6"
        >
          <div className="bg-gradient-to-r from-mas10-primary to-mas10-secondary rounded-3xl p-8 md:p-12 text-white">
            <h3 className="text-3xl md:text-4xl font-display font-bold mb-4">
              Largamos en 3, 2, 1 ....
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              ¡Empezá ya a ahorrar tiempo!
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* Unified Download Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={onDownloadClick}
                className="bg-mas10-secondary text-white px-6 py-3 rounded-full font-bold text-base group flex items-center space-x-2 hover:bg-mas10-primary transition-all duration-300 shadow-lg"
              >
                <Download className="w-5 h-5 group-hover:animate-bounce" />
                <span>Descargar App</span>
              </motion.button>

              {/* Iniciar Sesión (Entrenador) Button */}
              <motion.a
                href="https://plans.mastrainerapp.com/login"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-mas10-secondary text-white px-6 py-3 rounded-full font-bold text-base group flex items-center space-x-2 hover:bg-mas10-primary transition-all duration-300 shadow-lg"
              >
                <LogIn className="w-5 h-5 group-hover:animate-pulse" />
                <span>Iniciar Sesión (Entrenador)</span>
              </motion.a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HighlightReel;
